import { JSX } from "react";

import { MODULE_PULL_REQUESTS_COLUMN_ID } from "../../constants";
import { ModulePullRequestsTableRunCellProps } from "../types";
import ModulePullRequestsTableRunDeltaCell from "./DeltaCell";
import ModulePullRequestsTableRunEmptyCell from "./EmptyCell";
import ModulePullRequestsTableRunOpenedAtCell from "./OpenedAtCell";
import ModulePullRequestsTableRunStatusCell from "./StatusCell";
import ModulePullRequestsTableRunTitleCell from "./TitleCell";
import ModulePullRequestsTableRunVendorCell from "./VendorCell";

export const MODULE_PULL_REQUESTS_RUN_CELLS: Record<
  string,
  (props: ModulePullRequestsTableRunCellProps) => JSX.Element
> = {
  [MODULE_PULL_REQUESTS_COLUMN_ID.STATUS]: ModulePullRequestsTableRunStatusCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.TITLE]: ModulePullRequestsTableRunTitleCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.PR]: ModulePullRequestsTableRunEmptyCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.BRANCH]: ModulePullRequestsTableRunEmptyCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.AUTHOR]: ModulePullRequestsTableRunEmptyCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.VENDOR]: ModulePullRequestsTableRunVendorCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.DELTA]: ModulePullRequestsTableRunDeltaCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.OPENED_AT]: ModulePullRequestsTableRunOpenedAtCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.UPDATED_AT]: ModulePullRequestsTableRunEmptyCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS]: ModulePullRequestsTableRunEmptyCell,
};
